import React from 'react';
import './Header.css';
import { useTenant } from '../contexts/TenantContext';

const Header = ({ user, onMenuToggle }) => {
  const { tenant } = useTenant();

  return (
    <header className="header">
      <button className="mobile-menu-toggle" onClick={onMenuToggle} aria-label="Toggle menu">
        ☰
      </button>
      <div className="header-content">
        <h1 className="header-title">Kohinoor @ Patel Estate</h1>
        <div className="header-actions">
          <div className="header-user">
            <span style={{ fontWeight: '600', color: '#1a1a1a' }}>{tenant.name}</span>
            <span style={{ margin: '0 8px', color: '#9ca3af' }}>|</span>
            <span>{user?.name || 'Admin User'}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

